<template>
  <div class="sli-doc-icon">
    <button
      type="button"
      class="sli-doc-icon__btn"
      :class="{ 'is-on': files.length }"
      :title="label"
      :aria-label="label"
      @click="open = !open"
    >
      <feather-icon
        icon="PaperclipIcon"
        size="18"
      />
      <span
        v-if="files.length"
        class="sli-doc-icon__badge"
      >{{ files.length }}</span>
    </button>
    <div
      v-if="open"
      class="sli-doc-icon__panel"
    >
      <header class="sli-doc-icon__head">
        <strong>{{ label }}</strong>
        <button
          type="button"
          class="sli-link-btn"
          @click="open = false"
        >
          إغلاق
        </button>
      </header>
      <label
        v-if="!readonly"
        class="sli-doc-icon__drop"
      >
        <feather-icon
          icon="UploadIcon"
          size="16"
        />
        <span>رفع أو استبدال مستند</span>
        <input
          :key="fileKey"
          type="file"
          multiple
          :accept="accept"
          class="sli-doc-icon__input"
          @change="onInput"
        >
      </label>
      <small
        v-if="!readonly"
        class="sli-doc-icon__hint"
      >pdf / jpg / png / webp — حد أقصى 20 ميجا</small>
      <div
        v-if="files.length"
        class="sli-doc-icon__list"
      >
        <div
          v-for="(item, index) in files"
          :key="item.id || item.preview || item.name + index"
          class="sli-doc-icon__row"
        >
                <a
                  v-if="item.url || item.download_url"
                  :href="item.download_url || item.url"
                  target="_blank"
                  rel="noopener"
                  class="sli-doc-icon__preview"
                >
            <img
              v-if="isImage(item)"
              :src="item.url"
              :alt="item.name"
            >
            <span v-else>PDF</span>
          </a>
          <div
            v-else
            class="sli-doc-icon__preview"
          >
            <img
              v-if="item.preview"
              :src="item.preview"
              :alt="item.name"
            >
            <span v-else>PDF</span>
          </div>
          <div class="sli-doc-icon__meta">
            <span class="sli-doc-icon__name">{{ item.name }}</span>
            <small>{{ item.existing ? 'مرفق محفوظ' : formatSize(item.size) }}</small>
          </div>
          <button
            v-if="!readonly"
            type="button"
            class="sli-link-btn"
            @click="$emit('remove', index)"
          >
            حذف
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileIsAllowed, MAX_FILE_BYTES } from '../formModel'

export default {
  name: 'SliDocIcon',
  props: {
    files: { type: Array, default: () => [] },
    label: { type: String, default: 'المستند الدال على الشهر' },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false,
      fileKey: 0,
    }
  },
  watch: {
    files: {
      immediate: true,
      handler(list) {
        if (this.readonly && Array.isArray(list) && list.length) this.open = true
      },
    },
  },
  computed: {
    accept() {
      return '.pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp'
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
  },
  methods: {
    isImage(item) {
      const mime = item.mime || (item.file && item.file.type) || ''
      const name = (item.name || '').toLowerCase()
      return mime.startsWith('image/') || /\.(jpg|jpeg|png|webp)$/.test(name)
    },
    formatSize(bytes) {
      if (!bytes) return ''
      if (bytes < 1024) return `${bytes} بايت`
      if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} ك.ب`
      return `${(bytes / (1024 * 1024)).toFixed(1)} م.ب`
    },
    onInput(event) {
      const files = event.target.files
      const list = files ? Array.from(files) : []
      const accepted = []
      list.forEach(file => {
        if (!fileIsAllowed(file)) {
          if (file.size > MAX_FILE_BYTES) {
            this.$toast.error(`الملف ${file.name} أكبر من 20 ميجا`)
          } else {
            this.$toast.error(`نوع الملف غير مسموح: ${file.name}`)
          }
          return
        }
        const isPdf = (file.type || '').includes('pdf') || file.name.toLowerCase().endsWith('.pdf')
        accepted.push({
          file,
          name: file.name,
          size: file.size,
          mime: file.type,
          preview: isPdf ? null : URL.createObjectURL(file),
          existing: false,
        })
      })
      this.fileKey += 1
      if (accepted.length) this.$emit('add', accepted)
    },
    onDocClick(event) {
      if (this.readonly) return
      if (!this.$el.contains(event.target)) this.open = false
    },
  },
}
</script>
